import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary';
import ErrorPage from '@components/ErrorBoundary/ErrorPage/ErrorPage';
import Meta from '@components/Meta/Meta';
import { Route, Routes } from 'react-router';
import PageLayout from 'src/layouts/PageLayout/PageLayout';
import SentinelLayout from 'src/layouts/SentinelLayout/SentinelLayout';
import Home from './Home/Home';
import NotFound from './NotFound/NotFound';
import ProcessView from './Sentinel/ProcessView/ProcessView';
import SentinelHome from './Sentinel/SentinelHome/SentinelHome';

export default function App() {
	return (
		<ErrorBoundary errorComponent={ErrorPage}>
			<Meta />
			<Routes>
				<Route element={<PageLayout />}>
					<Route path="/" element={<Home />} index />
					<Route path="/sentinel" element={<SentinelLayout />}>
						<Route element={<SentinelHome />} index />
						<Route path="process" element={<ProcessView />} />
					</Route>
				</Route>
				<Route path="*" element={<NotFound />} />
			</Routes>
		</ErrorBoundary>
	);
}
